import React from 'react';

export interface IconButtonProps {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  id?: string;
  ['data-pw']?: string;
}

export const IconButton: React.FC<IconButtonProps> = (props) => {
  return (
    <button
      data-pw={props['data-pw'] ?? props.id}
      className={'styled-icon-button ' + (props.className ?? '')}
      onClick={props.onClick}
      type="button"
    >
      {props.children}
    </button>
  );
};
